import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'msc-showroom-exhibit-upload-page',
    templateUrl: './showroom-exhibit-upload-page.component.html',
    styleUrls: ['./showroom-exhibit-upload-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ShowroomExhibitUploadPageComponent {

}
